import Vue from 'vue';

import {
  APP_LOADER_FLAG_TOGGLE,
  APP_URLPARAMS_SET,
  APP_CONTENT_SET,
  APP_MESSAGE_SET,
} from '../mutations-types'

const state = {
  appSize: null,
  isLoaderActive: false,
  content: null,
  company: null,
  message: null,
};

const getters = {
  isLoaderActive: state => state.isLoaderActive,
  URLParams: state => state.URLParams,
  content: state => state.content,
  company: state => state.company,
  message: state => state.message,
};

const mutations = {
  [APP_LOADER_FLAG_TOGGLE](state, flag) {
    Vue.set(state, 'isLoaderActive', flag);
  },

  [APP_URLPARAMS_SET](state, params) {
    Vue.set(state, 'URLParams', params);
  },

  [APP_CONTENT_SET](state, data) {
    let content = data.content;

    if (content.flow[2].content) {
      content.flow[2].content = content.flow[2].content.replace('{report-fee}', data.defaultProcessingFee)
      //---fix api type
      content.flow[2].showWarning = content.flow[2].showWarning === 'true' || content.flow[2].showWarning === true

    }
    Vue.set(state, 'content', content);
    Vue.set(state, 'company', data.company);
  },

  /**
   * @params
   * data obj
   * title: string
   * text: string
   * **/
  [APP_MESSAGE_SET](state, data) {
    Vue.set(state, 'message', data);
  },

};


const actions = {
  APP_CONTENT_REQUEST_GET ({commit}, slug) {
    return new Promise((resolve, reject) => {
      Vue.axios.get('content/' + slug)
        .then(responseContent => {
          Vue.axios.get('company')
            .then(responseCompany => {
              commit(APP_CONTENT_SET, {
                content: JSON.parse(responseContent.data.content),
                defaultProcessingFee: responseCompany.data.defaultProcessingFee,
                company: responseCompany.data
              })
              resolve()
            }).catch( error => {
            reject(error.response.data && error.response.data.message ? error.response.data.message: error.response.data ? error.response.data: error.response)
          });
        }).catch( error => {
        reject(error.response.data && error.response.data.message ? error.response.data.message: error.response.data ? error.response.data: error.response)
      });
    })
  },
}
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};